export default __webpack_public_path__ + "static/media/team2.f222847d.png";